import { useTranslation } from 'react-i18next'

export const ProductCell = ({ productId, summary }) => {
  const { i18n } = useTranslation()
  if (!summary) return <span className="text-gray-500">{i18n.t('found_stock.queue.product_fallback', { id: productId })}</span>
  return (
    <div>
      <div className="font-medium text-gray-900">{summary.name}</div>
      {summary.skus.length > 0 && <div className="text-xs text-gray-500">{summary.skus.join(', ')}</div>}
      {summary.storeName && <div className="text-xs text-gray-500">{summary.storeName}</div>}
    </div>
  )
}
